// src/utils/currencyUtil.js

/**
 * Format currency amount
 * @param {number} amount - Amount to format
 * @param {string} currency - Currency code (default: LKR)
 * @returns {string} Formatted currency string
 */
export const formatCurrency = (amount, currency = null) => {
  const numAmount = parseFloat(amount);
  if (typeof numAmount !== 'number' || isNaN(numAmount)) return '0.00';

  if (currency) {
    return new Intl.NumberFormat('en-US', {
      style: 'currency',
      currency: currency,
      minimumFractionDigits: 2,
      maximumFractionDigits: 2
    }).format(numAmount);
  }else{
    return new Intl.NumberFormat('en-US', {
      style: 'decimal',
      minimumFractionDigits: 2,
      maximumFractionDigits: 2
    }).format(numAmount);
  }
};

/**
 * Format a currency amount for a compact card display: below LKR 10,000,000 returns the normal
 * 2-decimal form; at/above it, returns a millions-compact form (e.g. "1.23M"), matching the
 * exact truncation formula provided by the business. `title` always carries the full exact value
 * for a native-tooltip on hover.
 * @param {number} amount
 * @returns {{ display: string, title: string }}
 */
export const formatCurrencyCompact = (amount) => {
  const number = parseFloat(amount) || 0;
  const full = `LKR ${formatCurrency(number)}`;
  if (number >= 10000000) {
    const displayValue = parseFloat((Math.floor(number / 10000) / 100).toFixed(2));
    return { display: `${displayValue}M`, title: full };
  }
  return { display: formatCurrency(number), title: full };
};